import React, { useState } from 'react';
import { TextField, Button, Typography, Grid, CircularProgress } from '@mui/material';
import { requestPasswordReset } from '../../api/authApi';
import { CenteredGrid, StyledPaper, FormBox, SubmitButton, MessageText } from './ForgotPassword.styles';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isRequesting, setIsRequesting] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setMessage('');
        setError('');
        setIsRequesting(true);

        try {
            const data = await requestPasswordReset(email);
            setMessage(
                data.message || 'If your email is registered, you will receive a reset link.'
            );
        } catch (err) {
            setError(
                err?.response?.data?.message ||
                err.message ||
                'Failed to send password reset request.'
            );
        } finally {
            setIsRequesting(false);
        }
    };

    return (
        <CenteredGrid container>
        <Grid item xs={12} sm={8} md={6} lg={4}>
            <StyledPaper elevation={3}>
            <Typography variant="h5" component="h1" align="center" gutterBottom>
                Forgot Password
            </Typography>

            {message && (
                <Typography sx={{ ...MessageText, color: 'success.main' }}>
                {message}
                </Typography>
            )}

            {error && (
                <Typography sx={{ ...MessageText, color: 'error.main' }}>
                {error}
                </Typography>
            )}

            <FormBox component="form" onSubmit={handleSubmit}>
                <TextField
                type="email"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                />
                <Button 
                    type="submit" 
                    fullWidth 
                    variant="contained" 
                    sx={SubmitButton}
                    disabled={isRequesting}
                    startIcon={isRequesting ? <CircularProgress size={16} /> : null}
                >
                    {isRequesting ? 'Requesting...' : 'Request Reset Link'}
                </Button>
            </FormBox>
            </StyledPaper>
        </Grid>
        </CenteredGrid>
    );
}

export default ForgotPassword;
